import { Toaster } from '@/components/ui/toaster';
import { AppRoutes } from '@/routes';
import { Header } from '@/components/layout/Header';
import { AuthProvider } from '@/contexts/AuthContext';
import { CreditProvider } from '@/contexts/CreditContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from '@/pages/LandingPage';
import { AuthPage } from '@/pages/auth';
import { ContentWizard } from '@/pages/ContentWizard';
import { ProfilePage } from '@/pages/ProfilePage';
import { EditContent } from '@/pages/EditContent';
import { StoryboardPage } from '@/pages/StoryboardPage';
// Pricing paused during private beta — /pricing shows BetaAccessPage instead.
// To re-enable public pricing, restore `import PricingPage from './pages/PricingPage';`
// and swap the /pricing route element back to <PricingPage />.
import BetaAccessPage from './pages/BetaAccessPage';
import AuthCallback from '@/pages/auth/callback';
import VerifyPage from '@/pages/auth/verify';
import { DashboardPage } from '@/pages/Dashboard';
import { ShowcasePage } from '@/pages/Showcase';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { CheckoutSuccessPage } from '@/pages/CheckoutSuccessPage';
import { Analytics } from "@vercel/analytics/react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      retry: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CreditProvider>
          <div className="min-h-screen bg-gray-50">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/auth/verify" element={<VerifyPage />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/pricing" element={<BetaAccessPage />} />
                <Route path="/showcase" element={<ShowcasePage />} />
                <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                
                {/* Protected Routes */}
                <Route path="/dashboard" element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                } />
                <Route path="/create" element={
                  <ProtectedRoute>
                    <ContentWizard />
                  </ProtectedRoute>
                } />
                <Route 
                  path="/edit/:id" 
                  element={
                    <ProtectedRoute>
                      <EditContent />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/storyboard/:id" 
                  element={
                    <ProtectedRoute>
                      <StoryboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/*" 
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } 
                />
                
                {/* 404 catch-all route */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Toaster />
            <Analytics />
          </div>
        </CreditProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}